import React, { memo } from "react";

import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";
import CheckIcon from "ui/modules/fleet/vehicles/pages/VehicleDetailPage/components/VehicleDetailCard/components/VehicleEditCard/components/VehicleWizardIntro/scenes/CheckIcon";

import { getSelectedChannels, getVehicleImage, getVehicleName } from "../helpers";
import { ListingSceneProps } from "../types";
import ChannelTile from "./ChannelTile";

/** Korak odabira oglasnika: odabrani oglasnici s kvačicom, vozilo koje se oglašava i jedan unos za sve. */
const ChannelsScene: React.FC<ListingSceneProps> = ({ formValues }) => {
  const channels = getSelectedChannels(formValues);
  const vehicleName = getVehicleName(formValues);

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Objava na oglasnicima</div>
          <div className="text-sm font-bold text-slate-800 truncate">{vehicleName}</div>
          <div className="mt-3 space-y-2">
            {channels.map((channel) => (
              <div key={channel.id} className="flex items-center gap-3 rounded-md bg-slate-50 px-3 py-2">
                <ChannelTile code={channel.code} name={channel.name} />
                <span className="flex-1 min-w-0 text-[0.7rem] font-semibold text-slate-700 truncate">{channel.name}</span>
                <CheckIcon />
              </div>
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          {/* Slika vozila ima širok prozirni rub, pa se uvećava unutar okvira da auto ispuni karticu. */}
          <div className="h-[5.5rem] overflow-hidden">
            <img src={getVehicleImage(formValues)} alt="" className="w-full h-full object-contain scale-[1.4]" />
          </div>
          <div className="mt-2 text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Vozilo</div>
          <div className="text-sm font-bold text-slate-800 truncate">{vehicleName}</div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Podaci se unose jednom"
          subtitle="Svaki oglasnik ih preuzima"
          iconClassName="bg-blue-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#1D4ED8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M4 12h6M14 6h6M14 18h6M10 12l4-6M10 12l4 6" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(ChannelsScene);
